
var options = {
	rootMargin: "-200px 0px -200px 0px"
};

var { isExtraSmall, isMedium, isLarge } = require("./lib/breakpoints");

function activeSideNav(){

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			// console.log('entry', entry)
			const id = entry.target.getAttribute('id');
			if(document.querySelector(`nav.sideNav li a[href="#${id}"] p`) === null){
				console.log(`there is a problem with the: ${id} id`);
			}
			// console.log(document.querySelector(`nav#mainNav a[href="#${id}"]`))
			if(id != '' ){
			if (entry.intersectionRatio > 0) {
				document.querySelector(`nav.sideNav li a[href="#${id}"] p`).classList.add('active');
			} else {
				document.querySelector(`nav.sideNav li a[href="#${id}"] p`).classList.remove('active');	
					document.querySelector(`nav.sideNav li a[href="#${id}"] p`).classList.remove('active');	
				document.querySelector(`nav.sideNav li a[href="#${id}"] p`).classList.remove('active');	
			}
			}
		});
	},options);

	// // Track chapter sections and indicators
	var sections = ['.chapter', '.section', '.subsection'];

	sections.forEach((section) => {
		document.querySelectorAll(section).forEach((section) => {
			observer.observe(section);
		});
	});
	

}

activeSideNav();